import styled from 'styled-components'
import dsTheme from '../../constants/design-system/theme.json'
import { progressiveBreakpoints } from '../../constants/theme'
import smartyLightText from '../../static/images/smartyLightText.svg'
import smartyDarkText from '../../static/images/smartyNavOpen.svg'

const { colors, typography } = dsTheme

const NavbarContainer = styled.nav`
  background-color: ${(props) =>
    props.navbarOpen
      ? props.theme.colors.button.buttonColor
      : props.theme.colors.background.backgroundColorDarkest};
  position: relative;
  z-index: 1000;
  height: ${(props) => props.theme.sizes.navbarHeight};
  width: 100vw;
  max-width: 100%;
  @media ${progressiveBreakpoints.desktopSmall} {
    background-color: ${(props) =>
      props.theme.colors.background.backgroundColorDarkest};
  }

  .logo {
    display: block;
    width: 100px;
    height: ${(props) => props.theme.sizes.navbarHeight};
    color: ${(props) =>
      props.navbarOpen
        ? props.theme.colors.button.buttonColor
        : props.theme.colors.background.backgroundColorDarkest};
    text-indent: -10000px;
    background: url(${(props) =>
        props.navbarOpen ? smartyDarkText : smartyLightText})
      center center no-repeat;
    background-size: contain;
  }
`

const NavbarInner = styled.div`
  max-width: 940px;
  margin: 0;
  padding: 0 0 0 1em;
  display: flex;
  justify-content: space-between;
  // desktop because desktopSmall (iPad width) is cramped
  @media ${progressiveBreakpoints.desktop} {
    margin: 0 auto;
    padding: 0;
  }
`

const SubNav = styled.div`
  background-color: ${(props) => props.theme.colors.button.buttonColor};
  flex-direction: column;
  justify-content: flex-start;
  height: ${(props) => (props.navbarOpen ? '100vh' : 0)};
  left: 0;
  opacity: ${(props) => (props.navbarOpen ? 1 : 0)};
  overflow: scroll;
  position: fixed;
  right: 0;
  top: ${(props) => props.theme.sizes.navbarHeight};
  transition: height 0.25s ease-in;
  will-change: transform, opacity;

  a {
    color: ${(props) => props.theme.colors.background.backgroundColorDarkest};
  }

  @media ${progressiveBreakpoints.desktopSmall} {
    background-color: transparent;
    display: flex;
    flex: 1;
    flex-direction: row;
    height: ${(props) => props.theme.sizes.navbarHeight};
    justify-content: space-between;
    left: unset;
    opacity: 1;
    overflow: auto;
    position: relative;
    right: unset;
    top: 0;
    a {
      color: #fff;
    }
  }
`

const LinksWrapper = styled.div.attrs((props) => ({
  'data-testid': props.dataTestId || 'links-wrapper',
}))`
  display: ${(props) => (props.hideLinks ? 'none' : 'flex')};
  justify-content: flex-start;
  flex-direction: column;
  @media ${progressiveBreakpoints.desktopSmall} {
    display: flex;
    justify-content: space-between;
    flex: 1;
    flex-direction: row-reverse;
  }
`
// TODO: use design system variable when available

const NavLink = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: ${(props) => (props.isRow ? 'row' : 'column')};
  justify-content: flex-start;

  .link,
  .homelink,
  .link-tag {
    position: relative;
    display: inline-block;
    padding: 1rem;
    text-decoration: none;
    font-weight: 700;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    @media ${progressiveBreakpoints.desktop} {
      padding: 1.25rem;
    }
    &.mobile-only {
      @media ${progressiveBreakpoints.desktopSmall} {
        display: none;
      }
    }
  }

  .link-tag {
    color: #333539;
    position: relative;
    @media ${progressiveBreakpoints.desktopSmall} {
      color: #8ed6c9;
    }
    ::after {
      content: '';
      background: ${colors['Brand/PalePrimaryGreen']};
      position: absolute;
      height: 14px;
      padding: 0.25rem 0.313rem 0 0.313rem;
      display: inline-block;
      top: 1.25rem;
      left: 90%;
      border-radius: 2px;
      text-transform: uppercase;
      white-space: nowrap;
      text-align: center;
      @media ${progressiveBreakpoints.desktopSmall} {
        background: #8ed6c9;
        top: 1.5rem;
      }
    }
  }

  .link-tag-new {
    ::after {
      content: 'New';
      color: ${colors['Brand/PrimaryBlack']};
      font-size: 0.5rem;
      line-height: 1rem;
      padding: 0 0.5rem;
    }
  }

  .link-tag-coming {
    ::after {
      content: 'Coming soon';
      ${typography['Kollektif/TinyEmphasis']};
      line-height: 0.625rem;
      font-size: 0.5rem;
      letter-spacing: 0.063rem;
      color: ${colors['Brand/PrimaryBlack']};
      height: 0.75rem;
    }
  }

  .homelink {
    display: inline-block;
  }

  .activatelink,
  .loginlink,
  .dashboardlink {
    margin: 1rem;
    white-space: nowrap;
  }

  .loginlink {
    margin-right: 3.25rem;
    @media ${progressiveBreakpoints.desktopSmall} {
      margin-right: 1rem;
    }
  }
  .activatelink {
    display: flex;
    align-items: center;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    -webkit-font-smoothing: antialiased;
    background-color: #ffd67c;
    padding: 6px 15px;
    color: #333539 !important;
    @media ${progressiveBreakpoints.desktop} {
      margin-right: 0;
    }
  }

  .loginlink,
  .dashboardlink {
    display: flex;
    align-items: center;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    -webkit-font-smoothing: antialiased;

    background-color: ${(props) =>
      props.theme.colors.background.backgroundColor};
    color: #fff !important;
    padding: 6px 15px;

    img {
      margin: 0 5px 0 0;
      vertical-align: middle;
      height: 17px;
      width: 17px;
    }
  }

  .dashboardlink {
    @media ${progressiveBreakpoints.desktop} {
      margin-right: 0;
    }
  }

  @media ${progressiveBreakpoints.desktopSmall} {
    align-items: center;
    flex-direction: row;

    .homelink {
      display: none;
    }
  }
`

export { NavbarContainer, NavbarInner, SubNav, LinksWrapper, NavLink }
